import * as types from '@/store/mutation-types';
import MaskView from '@/components/common/MaskView.vue';
import ConfirmDialog from '@/components/common/Confirm.vue';
import settings from '@/utils/settings';
import Utils from '@/utils/Utils';
import Config from '@/utils/Config';


export default {
    name: 'Header',
    components: {
        MaskView,
        ConfirmDialog,
    },
    data() {
        return {
            blockURL: Config.BlockURL,
            isRouterAlive: true,
            lang: localStorage.getItem('lang') || 'en',
            host: Utils.getHostByCode(localStorage.getItem('host') || undefined),
            userId: '',
            hostArray: settings.HostArray,
            showList: -1,
            exportIndex: '',
            logoutstatus: false,
            logoutstatusConfirm: false,
            Config,
            confirmViewType: 'logout',
            confirmView: false,
            maskView: false,
            exportDialog: false,
        };
    },
    mounted() {
        document.title = Config.title;
        const link = document.querySelector("link[rel*='icon']");
        link.href = Config.WebsiteIcon;
        document.getElementsByTagName('head')[0].appendChild(link);
        const outRoutes = ['Login', 'Reg', 'GetToken'];
        console.log(this.currentRouteName);
        if (Config.CenterTrade && !this.user.email && !outRoutes.includes(this.currentRouteName)) {
            return this.$router.push('/Login');
        }
        return this.initUser();
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        },
        currAccountIndex() {
            return this.$store.state.currAccountIndex;
        },
        user() {
            return this.$store.state.user;
        },
        accountList() {
            return this.$store.state.accountList;
        },
    },
    watch: {
        currAccountIndex(n, o) {
            const self = this;
            if (n !== o && self.accountList && self.accountList[n]) {
                self.userId = self.accountList[n].userid;
            }
        },
        accountList(n, o) {
            const self = this;
            if (n !== o && self.accountList && self.accountList[self.$store.state.currAccountIndex]) {
                const currAccountIndex = self.$store.state.currAccountIndex;
                self.userId = self.accountList[currAccountIndex].userid;
            }
        },
    },
    methods: {
        changeLanguage(language) {
            localStorage.setItem('lang', language);
            location.reload();
        },
        gotoHome() {
            location.href = '/';
        },
        ok() {
            this.maskView = true;
            this.logoutstatus = false;
            this.logoutstatusConfirm = true;
            // this.confirmViewType = type;
        },
        cancel() {
        },
        logout() {
            if (Config.CenterTrade) {
                this.$store.commit(types.LOGOUT);
                localStorage.setItem('session', '{}');
                this.$router.push('/Login');
            } else {
                this.logoutstatus = true;
            }
        },
        hideLogoutDialog() {
            const self = this;
            self.logoutstatusConfirm = false;
            self.maskView = false;
        },
        hideMaskView() {
            const self = this;
            self.maskView = false;
            self.exportDialog = false;
        },
        goto(path) {
            if (!this.$store.getters.currAccount) {
                return this.$router.push('/Register');
            }
            return this.$router.push(path);
        },
        refresh() {},
        openWindow(url) {
            window.open(url, '_blank');
        },
        changeHost(code) {
            if (this.host.code !== code) {
                window.localStorage.setItem('host', code);
                window.location.href = window.location.href;
            }
        },
        initUser() {
            const self = this;
            if (
                self.$store.state.accountList &&
                self.$store.state.accountList.length > 0
            ) {
                const AccountList = self.$store.state.accountList;
                self.accountlist = AccountList;
                const currAccountIndex = self.$store.state.currAccountIndex;
                const currUser = AccountList[currAccountIndex];
                self.userId = currUser.userid;
            }
        },
        selectAccount(index) {
            const self = this;
            self.$store.commit(types.SELECT_ACCOUNT, index);
            self.userId = self.$store.state.accountList[self.$store.state.currAccountIndex].userid;
            // window.location.href = window.location.href
        },
        copyToClipboard(text) {
            if (window.clipboardData && window.clipboardData.setData) {
                // IE specific code path to prevent textarea being shown while dialog is visible.
                return clipboardData.setData("Text", text); 
        
            } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                var textarea = document.createElement("textarea");
                textarea.textContent = text;
                textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    return document.execCommand("copy");  // Security exception may be thrown by some browsers.
                } catch (ex) {
                    console.warn("Copy to clipboard failed.", ex);
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            }
        },
        handleListPanel(i, type = '') {
            const self = this;
            const index = i;
            if (type) {
                self.showList = type;
            } else {
                self.showList = index;
            }
        },
        onClickCopy(userId) {
            const self = this;
            this.copyToClipboard(userId);
            self.$Message.success(self.$t('balance_copy_success'));
        },
        viewAccount(userId) {
            window.open(
                `https://explorer.bytetrade.com/address.html?userId=${userId}`,
            );
        },
        
        exportAccount(index) {
            const self = this;
            if (index === self.userId) {
                self.exportIndex = self.$store.state.currAccountIndex;
            } else {
                self.exportIndex = index;
            }
            self.maskView = true;
            self.exportDialog = true;
        },
        hideExportDialog() {
            const self = this;
            self.exportDialog = false;
            self.maskView = false;
        },
        rucAction(action) {
            const self = this;
            self.$router.push(`/${action}`);
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/common/header.js